import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import {
  Wallet,
  setCorrectBalanceDialog,
} from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  HiOutlineAdjustmentsHorizontal,
  HiOutlineBanknotes,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../../../components/FormDialog";

const CorrectBalanceForm = (props) => {
  const dispatch = useDispatch();
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody
  );
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.user_id = props.userData.id;
    dispatch(Wallet.correctBalance(data, transactionsSearchBody)).then((x) => {
      dispatch(setCorrectBalanceDialog());
    });
  };

  const handleDialog = () => {
    dispatch(setCorrectBalanceDialog());
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_Wallet.correctBalanceDialog}
      onClose={handleDialog}
      icon={<HiOutlineAdjustmentsHorizontal />}
      title={"تعديل العملية"}
      subtitle="أدخل المبلغ وحدد الإضافة أو السحب من الرصيد"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات العملية">
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_deposit"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label={field.value ? "اضافة للرصيد" : "سحب من الرصيد"}
                onChange={(e) => setValue("is_deposit", e.target.checked)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            defaultValue={""}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CorrectBalanceForm;
